export const cardComponentExpand = () => ({
  type: 'expand',
});

export const cardComponentCollapse = () => ({
  type: 'collapse',
});
